'use client';

import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/ui-kit/utils';

const CHIP_TRANSITION = { type: 'spring' as const, stiffness: 500, damping: 38 };

interface FilterChipProps {
  layoutId: string;
  selected: boolean;
  onClick?: () => void;
  children: ReactNode;
}

function FilterChip({ layoutId, selected, onClick, children }: FilterChipProps) {
  return (
    <motion.button
      layoutId={layoutId}
      layout
      type="button"
      onClick={onClick}
      transition={CHIP_TRANSITION}
      className={cn(
        'flex h-8 cursor-pointer items-center justify-center rounded-[10px] px-3 py-2 outline-none',
        'text-[13px] font-normal leading-4 tracking-[-0.13px]',
        selected
          ? 'gap-1 bg-v2-btn-secondary-hover text-v2-text-primary'
          : 'bg-v2-btn-secondary-2 text-v2-text-secondary transition-colors hover:bg-v2-btn-secondary-hover hover:text-v2-text-primary',
      )}
    >
      <motion.span layout="position" className="whitespace-nowrap">
        {children}
      </motion.span>
      {selected && <X size={14} strokeWidth={1.75} />}
    </motion.button>
  );
}

export type { FilterChipProps };
export { CHIP_TRANSITION, FilterChip };
